import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { FullPage, Spinner } from "./Spinner";
import { useConfig } from "../state/config-context";
import { useSession } from "../state/session-context";

export function RequireAuth({ children }: { children: ReactNode }): ReactNode {
  const { t } = useConfig();
  const { status } = useSession();
  const location = useLocation();

  if (status === "loading") {
    return (
      <FullPage>
        <Spinner label={t("app.loading")} />
      </FullPage>
    );
  }

  if (status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
